import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { InviteRepository } from 'data/repository/invite-repository';
import { HelpTopicRepository } from 'data/repository/help-topic-repository';


@resource("help-Topic")
	@repository(HelpTopicRepository)
export class HelpTopic extends Entity {

	constructor() {
		super();
	}

	id: number;
	code: string;
	content: string;
	show: boolean = false;
}